/* eslint-disable */
export default {
  download: 'Scarica',
  play: 'Riproduci',
  pause: 'Metti in pausa',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
